import React, {useEffect, useState } from "react";
import "./AddRoleAcess.css";
const AddRoleAcess = ({
  title,
  isChecked,
  setIsChecked,
  accessValues,
  setAccessValues,
  checkBoxList,
  editValues,
}) => {
  const [selectedValue, setSelectedValue] = useState("");
  const { first, second} = isChecked;

  const returnAccessLevel = (value) => {
    switch (value) {
      case 0:
        return "access denied";

        case 4:
        return "access all";
      default:
        return "";
    }
  };

  const returnAccessNumber = (value) => {
    switch (value) {
      case "access all":
      case "first":
        return 4;
      case "access denied":
      case "second":
        return 0;

      default:
        return 0;
    }
  };

  const allSelectTitle = "Modules Permission";

  const handleOnChange = (event) => {
    const accessNumber = returnAccessNumber(event.target.value);
    const newAccessValues = [...accessValues];
    if (title === allSelectTitle) {
      for (const checkBox of checkBoxList) {
        const existingIndex = newAccessValues.findIndex(item => item.moduleName === checkBox);
        if (existingIndex >= 0) {
          newAccessValues[existingIndex].accessLevel = accessNumber;
        } else {
          newAccessValues.push({
            moduleName: checkBox,
            accessLevel: accessNumber,
          });
        }
      }
      newAccessValues.shift();
      setAccessValues(newAccessValues);

      setIsChecked({
        first: event.target.value === "first",
        second: event.target.value === "second",
      });
    } else {
      const existingIndex = newAccessValues.findIndex(item => item.moduleName === title);
      if (existingIndex >= 0) {
        newAccessValues[existingIndex].accessLevel = accessNumber;
      } else {
        newAccessValues.push({
          moduleName: title,
          accessLevel: accessNumber,
        });
      }
      setAccessValues(newAccessValues);
    }

    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (first) {
      setSelectedValue("access all");
    } else if (second) {
      setSelectedValue("access denied");
    }
  }, [isChecked]);

  useEffect(() => {
    if (editValues) {
      for (const item of editValues) {
        if (title === item.name) {
          setSelectedValue(returnAccessLevel(item.accessLevel));
        }
      }
    }
  }, [editValues, title]);

  return (
    <div className="main-container">
      <h6 
      className={
        title === allSelectTitle ? "access-title-selectAll" : "access-title"
        }
        >
        {title}
      </h6>
      <div className="radio-container">
        <label className="radio">
          <input
            type="radio"
            value={title === allSelectTitle ? "first" : "access all"}
            onChange={handleOnChange}
            checked={
              selectedValue === "access all" || selectedValue === "first"
            }
          />
          {title === allSelectTitle ? "Select All" : "Access All"}
        </label>
        <label className="radio">
          <input
            type="radio"
            value={title === allSelectTitle ? "second" : "access denied"}
            onChange={handleOnChange}
            checked={
              selectedValue === "access denied" || selectedValue === "second"
            }
          />
          {title === allSelectTitle ? "Select All" : "Access Denied"}
        </label>

      </div>
    </div>
  );
};

export default AddRoleAcess;
